/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MissingItem = {
  quantity: number;
  sku: string;
};

export type SmartPickingIssueType = "DAMAGED" | "EXPIRED" | "MISSING" | "WRONG";

export type VariablePriceInput = {
  price: number;
  sku: string;
};

export type ItemFragment = {
  id: string;
  sku: string | null;
  quantity: number | null;
  product: {
    name: string;
    imageUrl: string | null;
    sku: string;
    countryOfOrigin: { code: string | null };
    inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
    units: Array<{
      ean: string | null;
      type: string;
      quantity: number;
      variablePriceCode: string | null;
    }>;
    smartPickingAlert: { issueType: Types.SmartPickingIssueType } | null;
  } | null;
};

export type GetOrderDetailsQueryVariables = Exact<{
  orderId?: string | null | undefined;
  orderNumber?: string | null | undefined;
}>;

export type GetOrderDetailsQuery = {
  getOrderDetails: {
    ageVerification: string;
    createdAt: string | null;
    id: string;
    isClickAndCollect: boolean;
    isInStore: boolean;
    isNewCustomer: boolean;
    number: string | null;
    pickingItemCount: number;
    reseller: string;
    state: string | null;
    weight: number;
    deliveryTag: string | null;
    externalDeliveryProvider: string | null;
    handoverIdentifier: string | null;
    pickingDetails: {
      pickingState: string | null;
      startedBy: { id: string; displayName: string | null } | null;
      finishedBy: { id: string; displayName: string | null } | null;
      handoverDetails: {
        containerIds: Array<string> | null;
        shelfNumbers: Array<string> | null;
      } | null;
    } | null;
  };
};

export type StartPickingOrderMutationVariables = Exact<{
  orderId: string;
  isAlwaysInbound?: boolean | null | undefined;
  manualPicking?: boolean | null | undefined;
}>;

export type StartPickingOrderMutation = {
  startPickingOrder: {
    orderDetails: {
      ageVerification: string;
      createdAt: string | null;
      id: string;
      isClickAndCollect: boolean;
      isInStore: boolean;
      isNewCustomer: boolean;
      number: string | null;
      pickingItemCount: number;
      reseller: string;
      state: string | null;
      weight: number;
      deliveryTag: string | null;
      externalDeliveryProvider: string | null;
      handoverIdentifier: string | null;
      items: Array<{
        id: string;
        sku: string | null;
        quantity: number | null;
        product: {
          name: string;
          imageUrl: string | null;
          sku: string;
          countryOfOrigin: { code: string | null };
          inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
          units: Array<{
            ean: string | null;
            type: string;
            quantity: number;
            variablePriceCode: string | null;
          }>;
          smartPickingAlert: { issueType: Types.SmartPickingIssueType } | null;
        } | null;
      } | null>;
      pickingDetails: {
        pickingState: string | null;
        startedBy: { id: string; displayName: string | null } | null;
        finishedBy: { id: string; displayName: string | null } | null;
        handoverDetails: {
          containerIds: Array<string> | null;
          shelfNumbers: Array<string> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type FinishPickingOrderMutationVariables = Exact<{
  orderId: string;
  missingItems?: Array<Types.MissingItem> | Types.MissingItem | null | undefined;
  containerIds?: Array<string> | string | null | undefined;
  shelfNumbers?: Array<string> | string | null | undefined;
  variablePrices?: Array<Types.VariablePriceInput> | Types.VariablePriceInput | null | undefined;
}>;

export type FinishPickingOrderMutation = { finishPickingOrder: { message: string } };

export const ItemFragmentDoc = gql`
  fragment itemFragment on Item {
    id
    sku
    quantity
    product(isAlwaysInbound: $isAlwaysInbound) {
      name
      imageUrl
      sku
      countryOfOrigin {
        code
      }
      inventoryEntry {
        shelfNumber
        stock {
          shelf
        }
      }
      units(isAlwaysInbound: $isAlwaysInbound) {
        ean
        type
        quantity
        variablePriceCode
      }
      smartPickingAlert {
        issueType
      }
    }
  }
`;
export const GetOrderDetailsDocument = gql`
  query getOrderDetails($orderId: String, $orderNumber: String) {
    getOrderDetails(orderId: $orderId, orderNumber: $orderNumber) {
      ageVerification
      createdAt
      id
      isClickAndCollect
      isInStore
      isNewCustomer
      number
      pickingItemCount
      reseller
      state
      weight
      deliveryTag
      externalDeliveryProvider
      handoverIdentifier
      pickingDetails {
        pickingState
        startedBy {
          id
          displayName
        }
        finishedBy {
          id
          displayName
        }
        handoverDetails {
          containerIds
          shelfNumbers
        }
      }
    }
  }
`;

/**
 * __useGetOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderDetailsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetOrderDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(
    GetOrderDetailsDocument,
    options,
  );
}
export function useGetOrderDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(
    GetOrderDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useGetOrderDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrderDetailsQuery,
    GetOrderDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>;
export function useGetOrderDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetOrderDetailsQuery | undefined, GetOrderDetailsQueryVariables>;
export function useGetOrderDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(
    GetOrderDetailsDocument,
    options,
  );
}
export type GetOrderDetailsQueryHookResult = ReturnType<typeof useGetOrderDetailsQuery>;
export type GetOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetOrderDetailsLazyQuery>;
export type GetOrderDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetOrderDetailsSuspenseQuery
>;
export type GetOrderDetailsQueryResult = Apollo.QueryResult<
  GetOrderDetailsQuery,
  GetOrderDetailsQueryVariables
>;
export const StartPickingOrderDocument = gql`
  mutation startPickingOrder(
    $orderId: String!
    $isAlwaysInbound: Boolean
    $manualPicking: Boolean
  ) {
    startPickingOrder(orderId: $orderId, manualPicking: $manualPicking) {
      orderDetails {
        ageVerification
        createdAt
        id
        isClickAndCollect
        isInStore
        isNewCustomer
        number
        pickingItemCount
        reseller
        state
        weight
        deliveryTag
        externalDeliveryProvider
        handoverIdentifier
        items {
          ...itemFragment
        }
        pickingDetails {
          pickingState
          startedBy {
            id
            displayName
          }
          finishedBy {
            id
            displayName
          }
          handoverDetails {
            containerIds
            shelfNumbers
          }
        }
      }
    }
  }
  ${ItemFragmentDoc}
`;
export type StartPickingOrderMutationFn = Apollo.MutationFunction<
  StartPickingOrderMutation,
  StartPickingOrderMutationVariables
>;

/**
 * __useStartPickingOrderMutation__
 *
 * To run a mutation, you first call `useStartPickingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPickingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPickingOrderMutation, { data, loading, error }] = useStartPickingOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *      manualPicking: // value for 'manualPicking'
 *   },
 * });
 */
export function useStartPickingOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartPickingOrderMutation,
    StartPickingOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartPickingOrderMutation, StartPickingOrderMutationVariables>(
    StartPickingOrderDocument,
    options,
  );
}
export type StartPickingOrderMutationHookResult = ReturnType<typeof useStartPickingOrderMutation>;
export type StartPickingOrderMutationResult = Apollo.MutationResult<StartPickingOrderMutation>;
export type StartPickingOrderMutationOptions = Apollo.BaseMutationOptions<
  StartPickingOrderMutation,
  StartPickingOrderMutationVariables
>;
export const FinishPickingOrderDocument = gql`
  mutation finishPickingOrder(
    $orderId: String!
    $missingItems: [MissingItem!]
    $containerIds: [String!]
    $shelfNumbers: [String!]
    $variablePrices: [VariablePriceInput!]
  ) {
    finishPickingOrder(
      orderId: $orderId
      missingItems: $missingItems
      containerIds: $containerIds
      shelfNumbers: $shelfNumbers
      variablePrices: $variablePrices
    ) {
      message
    }
  }
`;
export type FinishPickingOrderMutationFn = Apollo.MutationFunction<
  FinishPickingOrderMutation,
  FinishPickingOrderMutationVariables
>;

/**
 * __useFinishPickingOrderMutation__
 *
 * To run a mutation, you first call `useFinishPickingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishPickingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishPickingOrderMutation, { data, loading, error }] = useFinishPickingOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      missingItems: // value for 'missingItems'
 *      containerIds: // value for 'containerIds'
 *      shelfNumbers: // value for 'shelfNumbers'
 *      variablePrices: // value for 'variablePrices'
 *   },
 * });
 */
export function useFinishPickingOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishPickingOrderMutation,
    FinishPickingOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FinishPickingOrderMutation, FinishPickingOrderMutationVariables>(
    FinishPickingOrderDocument,
    options,
  );
}
export type FinishPickingOrderMutationHookResult = ReturnType<typeof useFinishPickingOrderMutation>;
export type FinishPickingOrderMutationResult = Apollo.MutationResult<FinishPickingOrderMutation>;
export type FinishPickingOrderMutationOptions = Apollo.BaseMutationOptions<
  FinishPickingOrderMutation,
  FinishPickingOrderMutationVariables
>;
